<h2 class="page-title">Direct Hit</h2>

<div class="card-section">
  <div class="panel-row">
    <div class="dh-panel tint-dh1">
      <b>Direct Hit 1</b>
      <div class="mt-2">
        <label class="form-label mb-1">URL</label>
        <input type="text" class="form-control form-control-sm"
          [(ngModel)]="this.data.supplier_implementation.direct_hits[0].url"
          placeholder="https://…">
      </div>
      <div class="my-2 text-muted small text-center">and</div>
      <div>
        <label class="form-label mb-1">Paste page source:</label>
        <textarea class="form-control form-control-sm" rows="3"
          placeholder="Paste page HTML here..."
          [(ngModel)]="this.data.supplier_implementation.direct_hits[0].page_source"></textarea>
      </div>
      <div class="mt-2 d-flex justify-content-end align-items-center gap-2">
        <span class="status-text">{{ this.schema_status[0] }}</span>
        <button class="btn btn-sm btn-outline-secondary" (click)="get_schema_values(0)">Try Schema</button>
      </div>
    </div>

    <div class="dh-panel tint-dh2">
      <b>Direct Hit 2</b>
      <div class="mt-2">
        <label class="form-label mb-1">URL</label>
        <input type="text" class="form-control form-control-sm"
          [(ngModel)]="this.data.supplier_implementation.direct_hits[1].url"
          placeholder="https://…">
      </div>
      <div class="my-2 text-muted small text-center">and</div>
      <div>
        <label class="form-label mb-1">Paste page source:</label>
        <textarea class="form-control form-control-sm" rows="3"
          placeholder="Paste page HTML here..."
          [(ngModel)]="this.data.supplier_implementation.direct_hits[1].page_source"></textarea>
      </div>
      <div class="mt-2 d-flex justify-content-end align-items-center gap-2">
        <span class="status-text">{{ this.schema_status[1] }}</span>
        <button class="btn btn-sm btn-outline-secondary" (click)="get_schema_values(1)">Try Schema</button>
      </div>
    </div>
  </div>
</div>

<div class="card-section">
  <div class="mb-3 d-flex align-items-center gap-3">
    <button class="btn btn-sm btn-outline-secondary" (click)="use_all_schema_values()">Add schema step to all fields</button>
    <span class="text-muted small">
      Row colours: red = must-have, yellow = should-have
      <span matTooltip="If the supplier does not provide some fields, it's okay to use the same element multiple times.">(?)</span>
    </span>
  </div>

  <table class="data-table">
    <thead>
      <tr>
        <th></th>
        <th colspan="2" class="tint-dh1 text-center">Direct Hit 1</th>
        <th colspan="2" class="tint-dh2 text-center">Direct Hit 2</th>
        <th>Schema step</th>
        <th>Use Fixed Value</th>
        <th>Selectors</th>
        <th>Go!</th>
        <th>Status</th>
      </tr>
      <tr>
        <th>Field</th>
        <th class="tint-dh1">Extracted</th>
        <th class="tint-dh1">Target</th>
        <th class="tint-dh2">Extracted</th>
        <th class="tint-dh2">Target</th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </thead>
    <tbody>

      <tr class="row-required">
        <td>Brand / Manufacturer</td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.oem_info.brand }}</td>
        <td class="tint-dh1">
          <form [formGroup]="oem_brand">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.oem_info.brand}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.oem_info.brand }}</td>
        <td class="tint-dh2">
          <form [formGroup]="oem_brand">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.oem_info.brand}}">
          </form>
        </td>
        <td><input type="checkbox" [(ngModel)]="useSchema.oem_info_brand" (change)="onChangeSchema('oem_info_brand')" title="Adds a schema step as first step; the selectors stay as fall-through for pages without schema"> Schema step</td>
        <td><input type="text" class="form-control form-control-sm" [(ngModel)]="sv.oem_info_brand" (blur)="onStaticValueBlur('oem_info_brand')" placeholder="Static…"></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.oem_info.brand.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('oem_brand')">Show</button>
          }
        </td>
        <td>
          @if (!sv.oem_info_brand) {
            <button class="btn btn-sm btn-primary" (click)="onSubmit_oem_brand()">Go!</button>
          }
        </td>
        <td class="status-text">{{ fieldStatus['oem_brand'] }}</td>
      </tr>

      <tr class="row-required">
        <td>Manufacturer Part Number</td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.oem_info.number }}</td>
        <td class="tint-dh1">
          <form [formGroup]="oem_number">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.oem_info.number}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.oem_info.number }}</td>
        <td class="tint-dh2">
          <form [formGroup]="oem_number">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.oem_info.number}}">
          </form>
        </td>
        <td><input type="checkbox" [(ngModel)]="useSchema.oem_info_number" (change)="onChangeSchema('oem_info_number')" title="Adds a schema step as first step; the selectors stay as fall-through for pages without schema"> Schema step</td>
        <td><input type="text" class="form-control form-control-sm" [(ngModel)]="sv.oem_info_number" (blur)="onStaticValueBlur('oem_info_number')" placeholder="Static…"></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.oem_info.number.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('oem_number')">Show</button>
          }
        </td>
        <td>
          @if (!sv.oem_info_number) {
            <button class="btn btn-sm btn-primary" (click)="onSubmit_oem_number()">Go!</button>
          }
        </td>
        <td class="status-text">{{ fieldStatus['oem_number'] }}</td>
      </tr>

      <tr>
        <td>GTIN / EAN</td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.oem_info.gtin }}</td>
        <td class="tint-dh1">
          <form [formGroup]="oem_gtin">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.oem_info.gtin}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.oem_info.gtin }}</td>
        <td class="tint-dh2">
          <form [formGroup]="oem_gtin">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.oem_info.gtin}}">
          </form>
        </td>
        <td><input type="checkbox" [(ngModel)]="useSchema.oem_info_gtin" (change)="onChangeSchema('oem_info_gtin')" title="Adds a schema step as first step; the selectors stay as fall-through for pages without schema"> Schema step</td>
        <td><input type="text" class="form-control form-control-sm" [(ngModel)]="sv.oem_info_gtin" (blur)="onStaticValueBlur('oem_info_gtin')" placeholder="Static…"></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.oem_info.gtin.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('oem_gtin')">Show</button>
          }
        </td>
        <td>
          @if (!sv.oem_info_gtin) {
            <button class="btn btn-sm btn-primary" (click)="onSubmit_oem_gtin()">Go!</button>
          }
        </td>
        <td class="status-text">{{ fieldStatus['oem_gtin'] }}</td>
      </tr>

      <tr class="row-required">
        <td>Name / Title</td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.internal_info.name }}</td>
        <td class="tint-dh1">
          <form [formGroup]="internal_name">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.internal_info.name}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.internal_info.name }}</td>
        <td class="tint-dh2">
          <form [formGroup]="internal_name">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.internal_info.name}}">
          </form>
        </td>
        <td><input type="checkbox" [(ngModel)]="useSchema.internal_info_name" (change)="onChangeSchema('internal_info_name')" title="Adds a schema step as first step; the selectors stay as fall-through for pages without schema"> Schema step</td>
        <td><input type="text" class="form-control form-control-sm" [(ngModel)]="sv.internal_info_name" (blur)="onStaticValueBlur('internal_info_name')" placeholder="Static…"></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.internal_info.name.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('internal_name')">Show</button>
          }
        </td>
        <td>
          @if (!sv.internal_info_name) {
            <button class="btn btn-sm btn-primary" (click)="onSubmit_internal_name()">Go!</button>
          }
        </td>
        <td class="status-text">{{ fieldStatus['internal_name'] }}</td>
      </tr>

      <tr>
        <td>Supplier Internal Number</td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.internal_info.number }}</td>
        <td class="tint-dh1">
          <form [formGroup]="internal_number">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.internal_info.number}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.internal_info.number }}</td>
        <td class="tint-dh2">
          <form [formGroup]="internal_number">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.internal_info.number}}">
          </form>
        </td>
        <td><input type="checkbox" [(ngModel)]="useSchema.internal_info_number" (change)="onChangeSchema('internal_info_number')" title="Adds a schema step as first step; the selectors stay as fall-through for pages without schema"> Schema step</td>
        <td><input type="text" class="form-control form-control-sm" [(ngModel)]="sv.internal_info_number" (blur)="onStaticValueBlur('internal_info_number')" placeholder="Static…"></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.internal_info.number.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('internal_number')">Show</button>
          }
        </td>
        <td>
          @if (!sv.internal_info_number) {
            <button class="btn btn-sm btn-primary" (click)="onSubmit_internal_number()">Go!</button>
          }
        </td>
        <td class="status-text">{{ fieldStatus['internal_number'] }}</td>
      </tr>

      <tr>
        <td>Description</td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.internal_info.description }}</td>
        <td class="tint-dh1">
          <form [formGroup]="internal_desc">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.internal_info.description}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.internal_info.description }}</td>
        <td class="tint-dh2">
          <form [formGroup]="internal_desc">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.internal_info.description}}">
          </form>
        </td>
        <td><input type="checkbox" [(ngModel)]="useSchema.internal_info_description" (change)="onChangeSchema('internal_info_description')" title="Adds a schema step as first step; the selectors stay as fall-through for pages without schema"> Schema step</td>
        <td><input type="text" class="form-control form-control-sm" [(ngModel)]="sv.internal_info_description" (blur)="onStaticValueBlur('internal_info_description')" placeholder="Static…"></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.internal_info.description.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('internal_desc')">Show</button>
          }
        </td>
        <td>
          @if (!sv.internal_info_description) {
            <button class="btn btn-sm btn-primary" (click)="onSubmit_internal_desc()">Go!</button>
          }
        </td>
        <td class="status-text">{{ fieldStatus['internal_desc'] }}</td>
      </tr>

      <tr>
        <td>Product Group</td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.internal_info.group }}</td>
        <td class="tint-dh1">
          <form [formGroup]="internal_group">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.internal_info.group}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.internal_info.group }}</td>
        <td class="tint-dh2">
          <form [formGroup]="internal_group">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.internal_info.group}}">
          </form>
        </td>
        <td><input type="checkbox" [(ngModel)]="useSchema.internal_info_group" (change)="onChangeSchema('internal_info_group')" title="Adds a schema step as first step; the selectors stay as fall-through for pages without schema"> Schema step</td>
        <td><input type="text" class="form-control form-control-sm" [(ngModel)]="sv.internal_info_group" (blur)="onStaticValueBlur('internal_info_group')" placeholder="Static…"></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.internal_info.group.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('internal_group')">Show</button>
          }
        </td>
        <td>
          @if (!sv.internal_info_group) {
            <button class="btn btn-sm btn-primary" (click)="onSubmit_internal_group()">Go!</button>
          }
        </td>
        <td class="status-text">{{ fieldStatus['internal_group'] }}</td>
      </tr>

      <tr>
        <td>Amount
          <span matTooltip="Here, only the extracted amount is relevant. Sonar will try to extract the actual number and divide the price by that number afterwards">(?)</span>
        </td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.prices.amount }}</td>
        <td class="tint-dh1">
          <form [formGroup]="price_amount">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.prices.amount}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.prices.amount }}</td>
        <td class="tint-dh2">
          <form [formGroup]="price_amount">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.prices.amount}}">
          </form>
        </td>
        <td></td>
        <td></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.prices.amount.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('price_amount')">Show</button>
          }
        </td>
        <td>
          <button class="btn btn-sm btn-primary" (click)="onSubmit_price_amount()">Go!</button>
        </td>
        <td class="status-text">{{ fieldStatus['price_amount'] }}</td>
      </tr>

      <tr class="row-required">
        <td>Price
          <span matTooltip="When extracting the price, a value in square brackets will be shown. This is the parsed price (text to decimal). Please make sure this value is correct. If not, you can change the language in the Metadata. If nothing works, don't finish implementing the page.">(?)</span>
        </td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.prices.price }} {{ parsedPrices[0] }}</td>
        <td class="tint-dh1">
          <form [formGroup]="price_price">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.prices.price}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.prices.price }} {{ parsedPrices[1] }}</td>
        <td class="tint-dh2">
          <form [formGroup]="price_price">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.prices.price}}">
          </form>
        </td>
        <td><input type="checkbox" [(ngModel)]="useSchema.prices_price" (change)="onChangeSchema('prices_price')" title="Adds a schema step as first step; the selectors stay as fall-through for pages without schema"> Schema step</td>
        <td><input type="text" class="form-control form-control-sm" [(ngModel)]="sv.prices_price" (blur)="onStaticValueBlur('prices_price')" placeholder="Static…"></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.prices.price.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('price_price')">Show</button>
          }
        </td>
        <td>
          @if (!sv.prices_price) {
            <button class="btn btn-sm btn-primary" (click)="onSubmit_price_price()">Go!</button>
          }
        </td>
        <td class="status-text">{{ fieldStatus['price_price'] }}</td>
      </tr>

      <tr class="row-required">
        <td>Decimal separator
          <span matTooltip="The character used to separate the integer part from the fractional part of the price. Changing this re-parses the extracted prices.">(?)</span>
        </td>
        <td class="tint-dh1"></td>
        <td class="tint-dh1">
          <select [(ngModel)]="this.data.supplier_implementation.basic_supplier_info.decimal_separator"
                  (change)="onChangeDecimalSeparator()">
            <option value="">Select separator</option>
            <option *ngFor="let separator of decimal_separator_options" [value]="separator">{{ separator }}</option>
          </select>
        </td>
        <td class="tint-dh2"></td>
        <td class="tint-dh2"></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>

      <tr>
        <td>Currency
          <span matTooltip="Optional when the currency is part of the price text (e.g. 'US $12.99'): the price text is parsed then. Otherwise enter the currency text exactly as shown on the page (at least 2 characters, e.g. 'US $'). The value in square brackets is the resolved ISO code. Ambiguous symbols like '$' resolve via the currency mapping in the Metadata or the supplier's default currency.">(?)</span>
        </td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.prices.currency_text }} {{ parsedCurrencies[0] }}</td>
        <td class="tint-dh1">
          <form [formGroup]="price_currency_text">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.prices.currency_text}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.prices.currency_text }} {{ parsedCurrencies[1] }}</td>
        <td class="tint-dh2">
          <form [formGroup]="price_currency_text">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.prices.currency_text}}">
          </form>
        </td>
        <td><input type="checkbox" [(ngModel)]="useSchema.prices_currency" (change)="onChangeSchema('prices_currency')" title="Adds a schema step as first step; the selectors stay as fall-through for pages without schema"> Schema step</td>
        <td><input type="text" class="form-control form-control-sm" [(ngModel)]="sv.prices_currency_text" (blur)="onStaticValueBlur('prices_currency_text')" placeholder="Static…"></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.prices.currency_text.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('price_currency_text')">Show</button>
          }
        </td>
        <td>
          @if (!sv.prices_currency_text) {
            <button class="btn btn-sm btn-primary" (click)="onSubmit_price_currency_text()">Go!</button>
          } @else {
            <button class="btn btn-sm btn-outline-secondary" (click)="fetchParsedCurrencies()">Parse</button>
          }
        </td>
        <td class="status-text">{{ fieldStatus['price_currency_text'] }}</td>
      </tr>

      <tr>
        <td>VAT
          <span matTooltip="Optional when the VAT note is part of the price text (e.g. '19,99 € inkl. MwSt.'): the price text is parsed then. Otherwise enter the VAT text exactly as shown on the page (e.g. 'zzgl. 19 % MwSt.'). The value in square brackets is the resolved status. Texts the built-in markers don't know resolve via the VAT mapping in the Metadata; pages that say nothing use the supplier default from the Metadata.">(?)</span>
        </td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.prices.vat_text }} {{ parsedVats[0] }}</td>
        <td class="tint-dh1">
          <form [formGroup]="price_vat_text">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.prices.vat_text}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.prices.vat_text }} {{ parsedVats[1] }}</td>
        <td class="tint-dh2">
          <form [formGroup]="price_vat_text">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.prices.vat_text}}">
          </form>
        </td>
        <td><input type="checkbox" [(ngModel)]="useSchema.prices_vat" (change)="onChangeSchema('prices_vat')" title="Adds a schema step as first step; the selectors stay as fall-through for pages without schema"> Schema step</td>
        <td><input type="text" class="form-control form-control-sm" [(ngModel)]="sv.prices_vat_text" (blur)="onStaticValueBlur('prices_vat_text')" placeholder="Static…"></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.prices.vat_text.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('price_vat_text')">Show</button>
          }
        </td>
        <td>
          @if (!sv.prices_vat_text) {
            <button class="btn btn-sm btn-primary" (click)="onSubmit_price_vat_text()">Go!</button>
          } @else {
            <button class="btn btn-sm btn-outline-secondary" (click)="fetchParsedVats()">Parse</button>
          }
        </td>
        <td class="status-text">{{ fieldStatus['price_vat_text'] }}</td>
      </tr>

      <tr class="row-recommended">
        <td>Delivery</td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.prices.delivery_text }}</td>
        <td class="tint-dh1">
          <form [formGroup]="price_delivery_text">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.prices.delivery_text}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.prices.delivery_text }}</td>
        <td class="tint-dh2">
          <form [formGroup]="price_delivery_text">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.prices.delivery_text}}">
          </form>
        </td>
        <td></td>
        <td><input type="text" class="form-control form-control-sm" [(ngModel)]="sv.prices_delivery_text" (blur)="onStaticValueBlur('prices_delivery_text')" placeholder="Static…"></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.prices.delivery_text.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('price_delivery_text')">Show</button>
          }
        </td>
        <td>
          @if (!sv.prices_delivery_text) {
            <button class="btn btn-sm btn-primary" (click)="onSubmit_price_delivery_text()">Go!</button>
          }
        </td>
        <td class="status-text">{{ fieldStatus['price_delivery_text'] }}</td>
      </tr>

      <tr>
        <td>Condition</td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.condition }}</td>
        <td class="tint-dh1">
          <form [formGroup]="condition">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.condition}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.condition }}</td>
        <td class="tint-dh2">
          <form [formGroup]="condition">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.condition}}">
          </form>
        </td>
        <td></td>
        <td></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.condition.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('condition')">Show</button>
          }
        </td>
        <td>
          <button class="btn btn-sm btn-primary" (click)="onSubmit_condition()">Go!</button>
        </td>
        <td class="status-text">{{ fieldStatus['condition'] }}</td>
      </tr>

      <tr>
        <td>Price status</td>
        <td class="tint-dh1">{{ this.data.supplier_implementation.direct_hits[0].page_result.price_status }}</td>
        <td class="tint-dh1">
          <form [formGroup]="price_status">
            <input type="text" formControlName="input0"
              value="{{this.data.supplier_implementation.direct_hits[0].target_values.price_status}}">
          </form>
        </td>
        <td class="tint-dh2">{{ this.data.supplier_implementation.direct_hits[1].page_result.price_status }}</td>
        <td class="tint-dh2">
          <form [formGroup]="price_status">
            <input type="text" formControlName="input1"
              value="{{this.data.supplier_implementation.direct_hits[1].target_values.price_status}}">
          </form>
        </td>
        <td></td>
        <td></td>
        <td>
          @if (this.data.supplier_implementation.direct_hits_selectors.price_status.length > 0) {
            <button class="btn btn-sm btn-secondary" (click)="showSelectors('price_status')">Show</button>
          }
        </td>
        <td>
          <button class="btn btn-sm btn-primary" (click)="onSubmit_price_status()">Go!</button>
        </td>
        <td class="status-text">{{ fieldStatus['price_status'] }}</td>
      </tr>

    </tbody>
  </table>
</div>

<!-- selector overlay -->
<div id="overlay" (click)="overlay_off()">
  <div class="selector-modal" (click)="$event.stopPropagation()">
    <div class="selector-modal-header">
      <span id="overlay-title" class="selector-modal-title"></span>
      <div class="d-flex align-items-center gap-2">
        <button class="btn btn-sm btn-outline-primary" (click)="navigateToManager()">Go to Selectors Manager →</button>
        <button class="btn-close" (click)="overlay_off()"></button>
      </div>
    </div>
    <div class="selector-modal-body">
      <div id="text"></div>
    </div>
  </div>
</div>
